import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { HashRouter as Router } from 'react-router-dom';

// Styles
import './index.css';

// Utils
import { isDev } from '@utils/env';
import { setTokenHeader } from '@utils/api';
import { getOptionJsUrl } from '@utils/env';


const startApp = (config) => {
    const { client } = config;
    const pjson = require('../package.json');

    setTokenHeader(client.token);

    ReactDOM.render(
        <Router>
            <App />
        </Router>,
        document.getElementById('root')
    );

    document.querySelector('noscript').append(`Version: ${pjson.version}`);
};

window.startApp = startApp;

if (isDev()) {
    window.onload = function () {
        window.startApp({
            'client': {
                'token': 'SbYiOVvI6OPjZa9FtF8QNgGyH0if45JN'
            }
        });
    };
} else {
    const optionScript = document.createElement('script');
    optionScript.setAttribute('src', `${getOptionJsUrl()}/options.js`);
    document.querySelector('body').appendChild(optionScript);
}

serviceWorker.unregister();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
